import React from "react";
import { styled } from "@mui/material/styles";
import { FormBuilder } from "@/shared/components";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CardContent from "@mui/material/CardContent";
import type { FieldDefinition, TabDefinition } from "./types";

const PREFIX = "FormTabs";

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled("div")({
  [`&.${classes.root}`]: {
    flexGrow: 1,
  },
});

interface FormTabsProps {
  changeUrl?: boolean;
  classes?: any;
  schema: Record<string, TabDefinition>;
  initialValues: Record<string, any>;
  onSubmit: (tab: string, values: Record<string, any>) => void;
  // Предупреждения о несохраненных изменениях
  warnOnUnsavedChanges?: boolean;
  unsavedChangesWarningMessage?: string;
}

interface FormTabsState {
  value: string;
}

const getCurrentTab = (): string => {
  if (typeof window !== "undefined" && window.location) {
    return window.location.hash.replace("#", "");
  }
  return "";
};

export class FormTabs extends React.Component<FormTabsProps, FormTabsState> {
  static defaultProps: Partial<FormTabsProps> = {
    changeUrl: true,
  };

  constructor(props: FormTabsProps) {
    super(props);
    const firstSchema = Object.keys(this.props.schema)[0];
    const currentTab = getCurrentTab();
    this.state = {
      value: currentTab || firstSchema,
    };
  }

  handleChange = (_: React.SyntheticEvent, value: string) => {
    if (this.props.changeUrl && typeof window !== "undefined") {
      window.location.hash = value;
    }
    this.setState({ value });
  };

  renderTabs(): React.ReactNode[] {
    return Object.keys(this.props.schema).map((value) => (
      <Tab label={this.props.schema[value].label} value={value} key={value} />
    ));
  }

  getSchema(): Record<string, FieldDefinition> {
    const { schema } = this.props;
    const { value } = this.state;
    const [key] = Object.keys(schema);
    const firstTab = schema[key];

    if (schema[value]) {
      return schema[value].schema;
    }

    if (firstTab) {
      return firstTab.schema;
    }

    return {};
  }

  render(): React.ReactNode {
    const {
      initialValues,
      onSubmit,
      warnOnUnsavedChanges,
      unsavedChangesWarningMessage,
    } = this.props;
    const { value } = this.state;

    return (
      <Root className={classes.root}>
        <AppBar position="static">
          <Tabs value={value} onChange={this.handleChange}>
            {this.renderTabs()}
          </Tabs>
        </AppBar>
        <CardContent sx={{ pt: 4 }}>
          {Object.keys(this.props.schema).map((tab) => {
            const tabSchema = this.props.schema[tab].schema;
            return (
              <div
                key={tab}
                style={{ display: value === tab ? "block" : "none" }}
              >
                <FormBuilder
                  schema={{ ...tabSchema }}
                  initialValues={initialValues[tab] || {}}
                  onSubmit={(values: Record<string, any>) =>
                    onSubmit(tab, values)
                  }
                  warnOnUnsavedChanges={warnOnUnsavedChanges}
                  unsavedChangesWarningMessage={unsavedChangesWarningMessage}
                />
              </div>
            );
          })}
        </CardContent>
      </Root>
    );
  }
}
